'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".IconButton-module_iconButton__J3yqn{background:transparent;border:none;cursor:pointer;font-size:inherit;padding:0 .5rem}.IconButton-module_iconButton__J3yqn:hover{background:transparent}.IconButton-module_iconButtonHover__NnQHb{opacity:.3;transition:\"opacity 100ms ease-in-out\"}.IconButton-module_iconButtonHover__NnQHb:hover{background:transparent;opacity:1}";
var styles = {"iconButton":"IconButton-module_iconButton__J3yqn","iconButtonHover":"IconButton-module_iconButtonHover__NnQHb"};
styleInject["default"](css_248z, 'f355c6d8-9387-48f5-97b9-a1150b74e090');

exports["default"] = styles;
